import React from "react";
import {Button, CircularProgress} from '@material-ui/core';

export default function StandardButtonFit(props) {

    return (<div style={{position: "relative", direction: props.direction ? props.direction : "rtl"}}
                 onClick={props.onClick}>
        <div style={{opacity: !props.loading ? 100 : 0}}>
            {props.text ?
                <Button
                    endIcon={props.icon && props.icon}
                    variant={props.variant ? props.variant : "text"}>
                    <label
                        className={props.textcolor ? "marginLeftRightSmall " + props.textcolor : "marginLeftRightSmall"}>
                        {props.text}
                    </label>
                </Button> :
                <div>
                    {props.icon}
                </div>
            }
        </div>
        {props.loading &&
        <div style={{position: "absolute", top: "65%", left: "50%", transform: "translate(-50%,-50%)"}}>
            <CircularProgress size={25}/>
        </div>
        }

        {(props.badgenumber && props.badgenumber > 0) &&
        <div className="smallCircle smallIcon_1 whiteColor smallText center"
             style={{position: "absolute", top: "-1.3em", right: "-1.2em"}}>
            {props.badgenumber}
        </div>
        }
    </div>)
}